import { 商品区分型 } from '@/type/master/item';
import {Validator} from '@/type/validation/result';
import {半角カナ禁止, 必須入力, 日付書式, 時刻書式} from '@/type/validation/validator';

export interface 発注履歴照会依頼型 {
  メーカー名: string | null;
  商品名カナ: string | null;
  発注日From: Date;
  発注時刻From: string | null;
  発注日To: Date | null;
  発注時刻To: string | null;
  納品指定日From: Date | null;
  納品指定日To: Date | null;
  商品区分: 商品区分型 | null;
  卸コード: string | null;
  発注方法区分: 発注方法区分型 | null;
  確定送信者コード: string | null;
}

export enum 発注方法区分型 {
  オンライン = 'オンライン',
  FAX = 'FAX',
  電話 = '電話',
}

export interface 発注履歴照会結果型 {
  発注履歴一覧: 発注履歴照会型[];
  アラートメッセージ: string;
}

export interface 発注履歴照会型 {
  発注日: Date;
  発注時刻: string;
  発注伝票番号: string;
  発注伝票行番号: number;
  卸名: string;
  発注方法区分: 発注方法区分型;
  メーカー名: string;
  商品名: string;
  規格容量: string;
  発注数: number;
  発注単位名: string;
  納品指定日: Date;
  商品区分: 商品区分型;
  確定送信者名: string;
  使用区分: string;
}

export const 発注履歴照会依頼バリデータ一覧: Validator[] = [
  {
    name: '商品名カナ',
    constraints: [
      {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
    ],
  },
  {
      name: '発注日From',
      constraints: [
          {method: 必須入力, message: '発注日Fromは入力が必要です'},
          {method: 日付書式, message: '発注日Fromの書式が不正です'},
      ],
  },
  {
    name: '発注日To',
    constraints: [
      {method: 日付書式, message: '発注日Toの書式が不正です'},
    ],
  },
  {
    name: '発注時刻From',
    constraints: [
      {method: 時刻書式, message: '発注時刻Fromの書式が不正です'},
    ],
  },
  {
    name: '発注時刻To',
    constraints: [
      {method: 時刻書式, message: '発注時刻Toの書式が不正です'},
    ],
  },
  {
    name: '納品指定日From',
    constraints: [
        {method: 日付書式, message: '納品指定日Fromの書式が不正です'},
    ],
  },
  {
    name: '納品指定日To',
    constraints: [
      {method: 日付書式, message: '納品指定日Toの書式が不正です'},
    ],
  },
];
